import { Checkbox } from '@blueprintjs/core'
import React, { SFC } from 'react'

import { SyncIndicator } from './sync-indicator'
import { CheckboxProps, FieldAdapterProps } from './types'
import { createHelperText, createLabelWithId, createRequiredLabel, identity } from './utils'

export type Props = FieldAdapterProps<CheckboxProps>

const CheckboxAdapter: SFC<Props> = ({
  input,
  meta,
  disabled = false,
  inline,
  required,
  helperText,
  label,
  translate = identity,
  enableSyncControl,
  // tslint:disable-next-line:no-empty
  onSyncChange = (fieldName: string, newValue: boolean) => {},
}) => {
  const { id, labelText } = createLabelWithId(input, label)
  const helperTextMessage = createHelperText(meta, helperText, translate)
  const labelInfo = createRequiredLabel(required, translate)

  const labelElement = (
    <>
      {labelText} {labelInfo}{' '}
      {enableSyncControl && (
        <SyncIndicator translate={translate} fieldName={input.name} disabled={disabled} onSyncChange={onSyncChange} />
      )}
    </>
  )
  const checked = input.value

  return (
    <>
      <Checkbox
        id={id}
        checked={Boolean(checked)}
        disabled={disabled}
        inline={inline}
        labelElement={labelElement}
        {...input}
      />
      {helperTextMessage}
    </>
  )
}

export { CheckboxAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/checkbox-adapter.tsx